// Usando apenas APIs nativas de forma mais limpa
const toISOWithBrazilTZ = (date = new Date()) => {
    const formatter = new Intl.DateTimeFormat('sv-SE', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3
    });
    
    return formatter.format(date).replace(' ', 'T') + '-03:00';
};

export { toISOWithBrazilTZ };